'use strict';

var ajax = require('./ajax'),
    progress = require('./progress'),
    checkout = require('./pages/checkout'),
    formPrepare = require('./pages/checkout/formPrepare'),
    shipping = require('./pages/checkout/shipping'),
    util = require('./util'),
    tooltip = require('./tooltip'),
    dialogTooltip = require('./dialog-tooltip'),
    validator = require('./validator'),
    login = require('./login'),
    formPrepare = require('./pages/checkout/formPrepare'),
    tealium = require('../../../int_tealium/cartridge/js/tealium/tealium'),
    dialog = require('./dialog'),
    EDSPrescreen = require('../../../../SFRA/app_custom_fbb/cartridges/app_custom_fbb/cartridge/client/default/js/components/EDSPrescreen');
    require('./modal');
SessionAttributes = window.SessionAttributes;
var $cache = {},
    isSPCLogin = false,
    isSPCShipping = false,
    isSPCBilling = false,
    isExpressCheckout = false,
    hasSentPromotableOrNonPromotable = false,
    hasBeenPrescreened = false;

function initializeCache() {
    $cache = {
        main: $('#main'),
        primary: $('#primary'),
        secondary: $('#secondary'),
        all: $('#primary,#secondary')
    };
}

function initializeDom() {
    isSPCLogin = $('.spc-login').length > 0;
    isSPCShipping = $('.spc-shipping').length > 0;
    isSPCBilling = $('.spc-billing').length > 0;
    isExpressCheckout = $('.spc-express-checkout').length > 0;
}

function initShippingoverlay(){
    if($('#wrapper').hasClass('pt_checkout')  || $('.pt_order').length  || $('.pt_order-confirmation').length){
	    $('body').off('click','.shippingoverlay-link').on('click keypress','.shippingoverlay-link',function(e){
	        e.preventDefault();
	    	var shippingoverlay = $('#shipping-overlay').html();
            if (e.which == '13' || e.type == 'click') {
                dialog.open({
                    html: shippingoverlay,
                    options: {
                        width: 365,
                        dialogClass: 'shipping-overlay',
                        title: Resources.SHIPPING_OVERLAY_TITLE
                    }
                });
            }
            $('.ui-dialog.shipping-overlay .ui-dialog-titlebar-close')
                .addClass('btn-ds');
            tealium.triggerEvent({event_name: 'shipping_summary_tooltip', tealium_event: 'link'});
	    });
        //delivery options dialog-tooltip intialization
        $("body").off("click keypress",".dialog-tooltip").on("click keypress",".dialog-tooltip",function(e){
            if(e.type === "keypress"){
                if (e.which !== 13) return;
            }

            var content = $(this).parent().find(".tool-tip-content,.dialog-tool-tip-content").clone();
            var tootltipDlg =  dialog.create({
                target : "#tool-dialog-container",
                options:{
                    width: 360,
                    dialogClass : 'tool-dialog tooltip-dialog plcc-ssn-info-dialog',
                 }
             });
             $('.ui-dialog.plcc-ssn-info-dialog .ui-dialog-titlebar-close')
                    .addClass('btn-ds');
            $(tootltipDlg).children().remove();
            $(tootltipDlg).append(content);
            $(tootltipDlg).find('.dialog-tool-tip-content').removeClass('hide');
            tootltipDlg.dialog("open");

        });

    }
}

function initializeEvents() {
	util.updateInputFields();
	util.inputfocusEvent();
    validator.init();
	$(document).scroll(function() {
		if ( window.matchMedia("(min-width: 1024px)").matches ) {
            $('.checkout-order-summary').toggleClass('lg-md-absolute', $(window).scrollTop() > $('footer').offset().top - $('.checkout-order-summary').height() - $('.fixed-header').height());
		}
	});
	util.selectbox();
    if (isSPCLogin) {
        loadSPCLogin();
        login.init();
    } else if (isSPCShipping) {
        loadSPCShipping();
    } else if (isSPCBilling) {
        loadSPCBilling();
        if(!$(".ui-dialog").is(":visible")) {
        	scrollToActiveTab();
        }
    } else if (isExpressCheckout) {
    	loadExpressCheckout();
    }
    else {
    	/* Submit event is written only to show progress indicator to avoid multiple clicks by User SM-1549*/
    	$("#submit-order-details").off("submit").on("submit",function() {
            if ($('#ecoship-checkbox').length) {
                $('input[name="isEcoshipEnabled"]').val($('#ecoship-checkbox').prop("checked"));
                $('input[name="ecoshipDate"]').val($('.ecoship-delivery-date').attr('data-ecoship-date'));
            } else {
                $('input[name="isEcoshipEnabled"]').val('false');
                $('input[name="ecoshipDate"]').val('');
            }
            progress.show($("#main"));
            		// when a user logs out as guest the _subscribeToEmail checkbox does not exist in the DOM
            if (!hasSentPromotableOrNonPromotable && $(this).closest('form').find('input[name$=_subscribeToEmail]').length > 0) {
                // SC-1136: Trigger event for opt in status on click of the place order CTA
                hasSentPromotableOrNonPromotable = true;
                var addToEmailList = $(this).closest('form').find('input[name$=_subscribeToEmail]').is(':checked');
                tealiumAddToEmailListEvent(addToEmailList, '');
            }

            // Tealium checkout SMS sign-up
			if(SessionAttributes.IS_CUSTOMER_AUTHENTICATED) {
				if($(this).closest('form').find('input[name$=_smsSignUp]').length > 0 && typeof(utag_data) != 'undefined') {
					var smsSubscription = $(this).closest('form').find('input[name$=_smsSignUp]').is(':checked');
					var obj = {};
					obj.event_name = smsSubscription ? "sms_is_promotable" : "sms_is_not_promotable";
					obj.sms_opt_in_location = "Checkout Review";
					tealium.triggerEvent(obj);
				}
			} else {
				if(util.getCookie('guestsmsoptin') != ""){
					var guestSMSSignDetails = util.getCookie('guestsmsoptin');
					var detailsArray = guestSMSSignDetails.split('|');
					var obj = {};
					obj.event_name = detailsArray[1] == 'true' ? "sms_is_promotable" : "sms_is_not_promotable";
					obj.sms_opt_in_location = detailsArray[0];
					tealium.triggerEvent(obj);
				}
			}
    	});
    	/* Below method will show Q&A section of Summary Section */
    	util.showQuestionAndAnwser('summary-questions');

    	if ($('.spc-summary').length > 0) {
    		initCredit();
	    	$('.button-fancy-large.rightbutton.final-submit').removeAttr("disabled");
	    	if(!$(".ui-dialog").is(":visible")) {
	    		scrollToActiveTab();
	    	}
	    }
    }

    $('.pt_checkout').ajaxError(function () {
        window.location.href = Urls.cartShow;
    });

    $('a.tooltip').click(function (e) {
        e.preventDefault();
    });

    $('.privacy-policy').not('.pt_article-page .privacy-policy').on('click', function (e) {
        e.preventDefault();
        dialog.open({
            url: $(e.target).attr('href'),
            options: {
                height: 600
            }
        });
    });

    $('.show-basket-id').on('click',function(e){
        e.preventDefault();
        var options = {
            url: Urls.persisBasketCS,
            type: 'GET'
        };

        $.ajax(options).done(function(data) {

            if (typeof(data) !== 'string') {
                $('.shopping-bag-id').html('<span class="pid">ID<a href="#" class="show-basket-id" > '+data.basketID+'</a></span>');
            }

        });
    });

    initShippingoverlay();

    if($('#wrapper').hasClass('pt_order')){
    	$('body .order-status').each(function(index) {
    		$(this).on('click', '.order-history-overlay', function(e) {
    	        e.preventDefault();
    			var orderStatusOverlay = $('#order-status-overlay', $(this).parent()).html();
    	        dialog.open({
    	            html: orderStatusOverlay,
    	            options: {
    	                width: 365,
    	                dialogClass: 'order-status-overlay',
    	                title: 'order history status'
    	            }
    	        });
    		});
    	});
    }

    function generateUnderScore(n,length){
        if(!length){
            length=3;
        }
        n=length-n;
        var str='';
        for(var i=0;i<n;i++){
            str+='_';
        }
        return str;
    }

	function formatPhoneNumber(phoneNumber) {
		  var match = phoneNumber.match(/^(\d{3})(\d{3})(\d{4})$/);
		  if (match) {
		    return '(' + match[1] + ') ' + match[2] + '-' + match[3]
		  }
		  return null
	}

	$('.checkout-tab input.phone,.address-conatiner input.phone').off('input').on('input', function(e) {
	  var $phone = $(this),
	  	  numericDigits=$phone.val().replace(/\D/g,''),
	  	  start = this.selectionStart,
	      end = this.selectionEnd,
	      firstString = numericDigits.slice(0,3)? numericDigits.slice(0,3) : ' ',
	      secondString = numericDigits.slice(3, 6)? numericDigits.slice(3,6) : ' ',
	      thirdString = numericDigits.slice(6,10) ? numericDigits.slice(6,10) : ' ',
	      valLength=numericDigits.length,
	      inputType= e.originalEvent.inputType,
	      contentEdited=false,
	      formattedVal='(___) ___-____';

	  //Check if no entry is there or in last position
	  if(valLength===0){
		  start=end=1;
	  }

	  //Check If input type is backspace or delete
	  if(inputType==="deleteContentBackward" || inputType==="deleteContentForward"){
		  contentEdited=true;
	  }

	  $phone.attr('maxlength','');

	  if(valLength > 0 && valLength <= 3){

		formattedVal='('+ numericDigits + generateUnderScore(valLength) +') ___-____';
		if(start>=valLength){
			start=end=!contentEdited ? valLength+1 : start;
		}

	  }else if(valLength > 3 && valLength <=6){

		formattedVal='('+ firstString + ') '+ secondString + generateUnderScore(secondString.length) +'-____';
		if(start>=valLength+1){
			start=end=!contentEdited ? valLength+3 : start;
		}

	  }else if(valLength > 6){

		formattedVal='('+ firstString + ') '+ secondString +'-'+ thirdString + generateUnderScore(thirdString.length,4);
		if(start>=valLength+3){
			start=end=!contentEdited ? valLength+4 : start;
		}
	    if(valLength >= 10){
	    	$phone.attr('maxlength','14');
	    }

	  }
	  $phone.val(formattedVal);
	  this.setSelectionRange(start, end);

	});
	$('.checkout-tab input.phone,.address-conatiner input.phone').on('focusin click', function(e) {
	var $phone = $(this),
		valLength=$phone.val().replace(/\D/g,'').length;
	  if (valLength === 0) {
		  if($phone.val().length === 0){
			  $phone.val("(___) ___-____");
		  }
		  var start=1,end=1;
		  setTimeout($phone[0].setSelectionRange(start, end),0);
	  }
	});
	$('.checkout-tab input.phone,.address-conatiner input.phone').on('focusout', function() {
	  var $phone = $(this);
	  var numericDigits=$phone.val().replace(/\D/g,'');
	  if (numericDigits.length < 1) {
		 $phone.val('');
		 $phone.closest('.form-row').find('label').removeClass('input-focus');
	  }else if(numericDigits.length === 10){
		  $phone.val(formatPhoneNumber(numericDigits));
	  }
	});
        $cache.primary.on('click keypress', '.checkout-tab-head .edit-link[data-href], .left-content .edit-link[data-href], .right-content.payment .edit-link[data-href]', function (e) {
        if( !e.isTrigger && e.which != 1 && e.which != 13 || typeof(utag_data) !== 'undefined' && utag_data.event_name === 'PLCC_payment_edit' && $('.right-content.payment .edit-link ').length > 0 || $(this).data('disabled')){
            return;
        }
        e.preventDefault();
        e.stopPropagation();
        $(this).attr('data-disabled', true);
        progress.show($cache.main);
        var editShipping= $(this).hasClass('edit-Shipping');
        var stepVal = '',eventName='';
       
        util.newCreditCardTriggered = false;
        updateContent($(this).data('href'),$(this).data('checkoutstep'),editShipping);
      
        stepVal = $(this).data('checkoutstep');
        var isEdit = true;
        var registrationType;
        var addToEmailList;
        var plccEdit;
        // adding check for all plcc card type fb_plcc is working for only fb card
        var plccImgEle = this.parentElement.querySelector(".img");
        var plccCls= plccImgEle ? plccImgEle.classList[1] : '';
        var isPlcc = (plccImgEle !== null && plccCls && plccCls.indexOf('_plcc') !== -1);
        // fix for removing the duplicate event triggering when lick on payment edit from review and place order step
        if($(this).parent().hasClass('payment') && isPlcc) {
          plccEdit = true;
          tealiumEvent(stepVal,eventName,registrationType,addToEmailList,isEdit,plccEdit);
        } else {
          tealiumEvent(stepVal,eventName,registrationType,addToEmailList,isEdit);
        }

        setTimeout(function() {
            $(this).attr('data-disabled', false);
        }, 500);
       
    });


    $('.header-mian-banner').on('click', '.checkout-progress-indicator .inactive:not(.submitted) a', function (e) {
        e.preventDefault();
    });

    $('.header-mian-banner').off('click', '.checkout-progress-indicator .submitted a').on('click', '.checkout-progress-indicator .submitted a', function (e) {
        e.preventDefault();
        progress.show($cache.main);
        var href = $(this).attr('href');
        //Below code executes for express checkout scenario when clicked on step2 (Payment tab) : SM-4350
        if($(this).parent('.step-2').length > 0 && $('input[name$="_useAsBillingAddress"]').length > 0) {
        	href = util.appendParamToURL(href, 'isSameAsShipping', $('input[name$="_useAsBillingAddress"]').is(":checked"));
        }
        if($('.step-2.inactive.submitted a').length > 0) {
        	href = util.appendParamToURL(href, 'step2', 'true');
        }
        updateContent(href,$(this).find('.progress-count').text());
    });

    $('.header-mian-banner').on('click', '.checkout-progress-indicator .active a', function (e) {
        e.preventDefault();
        return false;
    });

    if ($('.submit-order').length > 0) {
    	$cache.secondary.find('.rightbutton').on('click',function(){
			$('.submit-order button').trigger('click');
		});
    }

    $('#primary').off('click', '.express-billing-refresh[data-refreshurl]').on('click', '.express-billing-refresh[data-refreshurl]', function (e) {
		e.preventDefault();
        progress.show('#main');
        var URL = $(this).attr('data-refreshurl');	//data('refreshurl') is not picking updated parameter values from the URL and hence replaced with this line
        ajax.load({
            url: URL,
            method: 'POST',
            callback: function (data) {
            	var content = $(data).find('.selectpayment').html();
            	if (content == undefined || content == null || content == '') {
            		content = $(data).filter('.selectpayment').html();
            	}
                $('#primary .selectpayment').html(content);
                handleBasketError();
                initSPC();
                validator.init();
                updateSummary(3);
                if($('.showcontent').length > 0){
                	$cache.primary.find('.toggle').next('.toggle-content').hide();
                	$cache.primary.find('.showcontent.toggle').next('.toggle-content').show();
                }
                else{
                	$cache.primary.find('.toggle').next('.toggle-content').hide();
                }
                $cache.primary.find('.toggle').click(function() {
                    $(this).toggleClass('expanded').next('.toggle-content').toggle();
                });

                util.updateselect();
                require('./pages/checkout/billing').init();

                var $basketSummary = $('.basket-details');
                // indicate progress
                progress.show($basketSummary);

                // load the updated summary area
                $basketSummary.load(Urls.basketRefreshURL, function () {
                    // hide edit shipping method link
                	$basketSummary.fadeIn('fast');
                });

                progress.hide();
            }
        });
    });

	$cache.primary.on('click', '.billing-refresh[data-refreshurl]', function (e) {
		e.preventDefault();
        progress.show($cache.main);
        updateContent($(this).data('refreshurl'),2);
    });

    $cache.secondary.on('click', '.order-component-block a, .order-totals-table .order-shipping a', function (e) {
        e.preventDefault();
        progress.show($cache.main);
        ajax.load({
            url: $(this).attr('href'),
            method: 'POST',
            callback: function (data) {
                $cache.primary.html(data);
                handleBasketError();
                initSPC();
                tooltip.init();
                util.limitCharacters();
                validator.init();
                checkout.init();
                progress.hide();
                updateAnchor();
            }
        });
    });
    //Open shipping fields on click of edit in shipping page
    $cache.primary.on('click keypress', '.shipping-add-edit', function (e, editship) {
			if( !e.isTrigger && e.which != 1 && e.which != 13 ){
				return;
			}
			  e.preventDefault();
        var $form = $('.address');
        var selected = $(this).closest($cache.primary).find('select[name$="_addressList"]').children(':selected').first();
        var selectedAddress = $(selected).data('address');
        util.fillAddressFields(selectedAddress, $form);
        $('.saved-address-count').removeClass('hide');
        $('.fieldsection').show();
        $('.fieldsection .form-row input').filter(function() { return $(this).val() == ""; }).closest('.field-wrapper').siblings('label').removeClass('input-focus');
        if (editship) {
        	if (selectedAddress != undefined) {
            	$('.fieldsection').hide();
            } else {
            	$('.edit-section').addClass('hide');
            }
        } else {
        	$('.edit-section').addClass('hide');
        	$('.save-section').removeClass('hide');
        }
        $('.nickname-field').find('input').val('');
        $('.checkout-shipping .saved-address-block .required-field').removeClass('hide');
    });

    //Hide Shipping fields on click of Cancel Edit in Shipping page
    $cache.primary.on('click keypress', '.shipping-cancel', function (e) {
			if(!e.isTrigger && e.which != 1 && e.which != 13 ){
				return;
			}
			e.preventDefault();
        var $form = $('.address');
        var selected = $(this).closest($cache.primary).find('select[name$="_addressList"]').children(':selected').first();
        var selectedAddress = $(selected).data('address');
        if (selectedAddress == undefined || selectedAddress == null) {
    		var selected = $('select[name$="_addressList"]').children(':selected').first();
    		var defaultFlag = $('select[name$="_addressList"]').find('option[data-isdefault]').length;
    		if(defaultFlag) {
    			$('select[name$="_addressList"]').find('option').removeAttr("selected");
    			$('select[name$="_addressList"]').find('option[data-isdefault]').attr("selected","selected");
    			$('select[name$="_addressList"]').find('option[data-isdefault]').prop("selected",true);
    			util.selectbox();
    			selected = $('select[name$="_addressList"]').children(':selected').first();
    		}
    		selectedAddress = $(selected).data('address');
    	} else {
    		if ($('select[name$="_addressList"]').find('option[data-selectedoption]').length > 0){
    			$('select[name$="_addressList"]').find('option[data-selectedoption]').siblings().removeAttr("selected");
        		$('select[name$="_addressList"]').find('option[data-selectedoption]').prop("selected",true);
        		util.selectbox();
        		selected = $('select[name$="_addressList"]').find('option[data-selectedoption]');
        		selectedAddress = $(selected).data('address');
    		}
    	}
        util.fillAddressFields(selectedAddress, $form);
        $('.fieldsection').hide();
        $('.saved-address-count').removeClass('hide');
        $('.edit-section').removeClass('hide');
        $('.save-section').addClass('hide');
        $('.checkout-shipping .saved-address-block .required-field').addClass('hide');
        formPrepare.init({
	    	continueSelector: '[name$="shippingAddress_save"],[name$="submit_form"]',
	        formSelector:'[id$="singleshipping_shippingAddress"]'
	    });
    });

    //To save edited shipping address in shipping page
    $cache.primary.on('click', '.shipping-save', function (e) {
    	 e.preventDefault();
         if(isExpressCheckout) { //SM-5844
             e.preventDefault();
             return false;
         }
        $('.saved-address-count').removeClass('hide');
        var form = $(this).closest('form');
        $('<input type="hidden" name="' + $(this).attr('name') + '" value="true" />').appendTo(form);
        var addressId = $('select[name$="_addressList"]').val();
        var url = form.attr('action');
        url = util.appendParamsToUrl(url, {
            AddressID: addressId,
            format: 'ajax'
        });

        form.validate();
        if (!form.valid()) {
            return false;
        }
        ajax.load({
            url: url,
            data: form.serialize(),
            method: 'POST',
            callback: function () {
            	$('.fieldsection').hide();
            	handleBasketError();
                tooltip.init();
                util.limitCharacters();
                validator.init();
                checkout.init();
                progress.hide();
                updateAnchor();
                progress.show($cache.main);
                updateContent(Urls.shippingStart,1);
            }
        });
    });


    // PXSFCC-3895 [E2E Blocker] Preapproval modal does not pop up for registered users with default address and saved payment methods
    if($('.spc-express-checkout').length > 0){
    	initCredit();
    }
   //SM-2124 fix global tooltip is applied and old code is removed.
    dialogTooltip.events();
    //SM-2177 - WW-Payment details section-New card fields with auto pre-filled data displaying, on hitting the "Enter" button from the keyboard
    if($('#wrapper').hasClass('pt_checkout')){
    	//Putting check for form submit on click of enter and paypal selected
    	$(document).on('keydown', function (e) {
            if((!$(document.activeElement).hasClass("coupon-code") && !$(document.activeElement).hasClass("apply")) && ($('#is-PayPal').is(':checked') && e.keyCode=='13' && ($('.checkout-billing').length > 0 || $('.spc-express-checkout').length > 0 ))){
                    e.preventDefault();
                    if($('.submit-express-order').length > 0){
                        $cache.primary.find('.spc-summary-btn').trigger('click');
                    }else{
                        $cache.primary.find('.spc-billing-btn').trigger('click');
                    }
            }
    	});

    	$cache.primary.on("keypress", ".checkout-billing.address input, .spc-express-checkout .payment-method input", function(event) {
	    	if ( event.keyCode === 13 && $(this).closest('.payment-method').find('.billingfields').length > 0){
	    		event.preventDefault();
	    		if($(this).val() !== '') {
	    			if($('.submit-express-order').length > 0){
		    			$cache.primary.find('.spc-summary-btn').trigger('click');
		    		}else{
		    			$cache.primary.find('.spc-billing-btn').trigger('click');
		    		}
	    		} else {
	    			return false;
	    		}
	    	}
	    });

    	$cache.primary.on("keydown", ".saved-address-block input, .spc-express-checkout .saved-address-block input", function(event) {
	    	if ( event.keyCode === 13 && $(this).closest('.checkout-billing').hasClass('address')){
	    		event.preventDefault();
	    		if($(this).val() !== '') {
	    			if($('.submit-express-order').length > 0){
		    			$cache.primary.find('.spc-summary-btn').trigger('click');
		    		}else{
		    			$cache.primary.find('.spc-saveAddr-btn').trigger('click');
		    		}
	    		} else {
	    			return false;
	    		}
	    	}
	    });
    }
    initiateSMSVibesPhoneInput();

    $('body').on('click','.perks-removed-from-cart .alert-close-button',function(){
        $('body').find('.perks-removed-from-cart').addClass('hide');
    });

    initAnalyticsEventForCheckoutRedirect();

}

function initAnalyticsEventForCheckoutRedirect() {
    if(util.getCookie('redirectToOldCheckout') != "" && util.getCookie('redirectToOldCheckoutAlreadyTriggered') !== "true"){
        tealium.triggerEvent({ event_name: 'ecoship_redirect_to_old_checkout'});
        util.createCookie("redirectToOldCheckoutAlreadyTriggered", "true", 1);
    }
}

function loadExpressCheckout () {
	updateSummary(3);
	window.enterKeyCheckoutFormSubmit = window.lastClickOrKey === 'key' ? true : false ;
    scrollToActiveTab();
    $cache.primary.find('.spc-login').trigger('ready');

    /* Below method will show Q&A section of Summary Section */
    util.showQuestionAndAnwser('summary-questions');

    require('./pages/checkout/expresscheckout').init();
    var prescreenData = $('.eds-customer-prescreened').data();
    if(!hasBeenPrescreened && !(prescreenData && prescreenData.screened === true)){
        hasBeenPrescreened = true;
        $('.eds-rtps-data').trigger('click');
        EDSPrescreen.submitRTPS(formToBuyer($('.express-checkout-billing')), 'checkout');
    }
}

function loadSPCLogin() {
    updateSummary(0);
    window.enterKeyCheckoutFormSubmit = window.lastClickOrKey === 'key' ? true : false ;
    scrollToActiveTab();
    $cache.primary.find('.spc-login').trigger('ready');

    /* Below method will show Q&A section of Login Section */
    util.showQuestionAndAnwser('checkout-login');
    $cache.secondary.find('.rightbutton').on('click',function(){
    	var userName = $('.login-form .username input').val();
    	var password = $('.login-form .password input').val();
    	var guestmail = $('.guest-form .emailAddress input').val();
    	if (userName != null && userName != '' && userName != undefined && password != null && password != undefined && password != '') {
    		$cache.primary.find('.spc-login-btn:not(:disabled)').trigger('click');
    	} else {
    		$cache.primary.find('.spc-guest-btn:not(:disabled)').trigger('click');
    	}
    });
    $cache.primary.on('click', '.spc-login-btn:not(:disabled)', function (e) {
        e.preventDefault();
        var form = $(this).closest('form'),stepVal = '', eventName;
        var checkpasswordreset = true;
        $('<input type="hidden" name="' + $(this).attr('name') + '" value="true" />').appendTo(form);
        var url = form.attr('action');
		url = util.appendParamToURL(url, 'ispasswordreset', checkpasswordreset);
        var $loginForm = $(document.getElementsByClassName('login-form'));
        util.validateLoginOnSubmit($loginForm);
        util.validateEmailOnFocusOut($loginForm);
        if ($('.login-form').valid()) {
            $('body').find('#pwd_error1').addClass('hide');
        } else {
            $('body').find('#pwd_error1').removeClass('hide');
        }
        if(!($('.login-form .password .password').val())) {
            $('body').find('#pwd_error1').removeClass('hide');
        } else {
            $('body').find('#pwd_error1').addClass('hide');
        }
        form.validate();
        if (!form.valid()) {
            return;
        }
        var url=$(this).closest('.login-form').attr('action');
        var emailField=$(this).closest('.login-form').find('input[name="email"]').attr('id');
        var emailFieldValue=$(this).closest('.login-form').find('.email').val();
        var password=$(this).closest('.login-form').find('input[name="password"]').attr('id');
        var passwordValue=document.getElementById(password).value;
        var csrf_token=$(this).closest('.login-form').find('input[name="csrf_token"]').val();
        var customerFound=$(this).closest('.login-form').find('input[name="customerFound"]').val();
        var LoginStatus=$(this).closest('.login-form').find('button[name="dwfrm_login_login"]').val();

        var data ={
            "csrf_token" : csrf_token,
            "customerFound" : customerFound,
            "dwfrm_login_login" : LoginStatus,
        }
        data[emailField] =emailFieldValue;
        data[password] =passwordValue;
        progress.show($cache.main);
        ajax.load({
            url: url,
            data: data,
            method: 'POST',
            callback: function (data) {
                var isJson = isValidJson(data);
                if (isJson) {
                    var validJSON = JSON.parse(data);
				    if (validJSON.isCountryMisMatchError === true) {
					    window.location = validJSON.redirectUrl;
				    }
                }
            	var dataJSON;
            	if(data) {
            		if((data.toString().indexOf('maxCartQty') != -1 && $(data).find("input[name=maxCartQty]").length > 0 && $(data).find("input[name=maxCartQty]").val() > 40) || (data.toString().indexOf('emptyCart') != -1)) {
            			window.location.href = Urls.cartShow;
            			return;
            		}
	            	if(data.toString().indexOf('status') != -1) {
	            		dataJSON = JSON.parse(data);
	            	}
                }

                if(dataJSON && dataJSON.status && dataJSON.showModalBox){
                    e.preventDefault();
                    //trigger event for this modal and attach events to the buttons
                    tealium.triggerEvent({ event_name: 'passwordmodal'});
                    dialog.open({
                        url:  util.appendParamToURL(util.appendParamToURL(dataJSON.url, 'format', 'ajax'), 'fromCheckout', 'true'),
                        closeOnEscape: true,
                        options : {
                            dialogClass: 'pt_account password_reset_checkout_modal',
                            width: 748,
                            open: function() {
                                $('.buttonOulined').click(function(e){
                                    e.stopPropagation();
                                    //3) When someone clicks on "Checkout as Guest" CTA, please fire a tealium link event with event_name: checkoutasguest
                                    tealium.triggerEvent({ event_name: 'checkoutasguest'});
                                    //close modal
                                    dialog.close();
                                });
                                //bind to reset password
                                bindAjaxToPasswordReset();
                                validator.init();

                                //2) When someone clicks on "Reset My Password" CTA, please fire a tealium link event with event_name: resetpassword
                                $('.reset_password_button').on('click', function(e) {
                                    e.preventDefault();
                                    tealium.triggerEvent({ event_name: 'resetpassword'});
                                });

                                //add class to 'X' button
                                $('.ui-dialog-titlebar-close').addClass('closeModalXButton btn-ds');
                                //4) When someone closes the modal by clicking on the "x" on the top right corner, please fire a tealium link event with event_name: closemodal

                                $('.closeModalXButton').bind('click', bindTealiumEventXButton );

                            }
                        }
                    });
                } else if(dataJSON && dataJSON.status) {
                	window.location.assign(Urls.passwordReset);
                } else {
                	$cache.primary.html(data);
                    handleBasketError();
                    initSPC();
                    validator.init();
                    if ($cache.primary.find('.spc-login').length === 0) {
                        tooltip.init();
                        util.limitCharacters();
                        checkout.init();
                        updateCustomerInfo();
                    }
                    $('.header-mian-banner').find('.checkout-progress-indicator').html($('.checkoutinfo').find('.checkout-progress-indicator').html());
                    if ($cache.primary.find('.spc-billing.giftcard-only').length > 0) {
                    	updateSummary(2)
                    }
                    progress.hide();
                    updateAnchor();
                    if ($cache.primary.find('.spc-login').length === 0) {
                        if($('.header-mian-banner').find('.checkout-progress-indicator .active .progress-count').length == 1){
                    		stepVal = $('.header-mian-banner').find('.checkout-progress-indicator .active .progress-count').text();
                    	}
                    	eventName = 'login-success';
                    	// SM-6239: Updated tealium authentication tracking for logged in user
    					if (typeof utag_data != 'undefined') {
    						utag_data.user_anonymous = "false";
    						utag_data.user_authenticated = "true";
    						utag_data.user_registered = "true";
    					}
                        /** trigger ajax call to fetch the utag data for checkout page on successful checkout login**/
                        if(typeof utag_data != 'undefined'){
                            var checkoutUtagURL=Urls.getCheckoutUtagData+'?stepVal='+stepVal;
                            $.ajax({
                                url: checkoutUtagURL,
                                method: 'GET',
                                success: function(data) {
                                    if(data !== ''){
                                        utag_data=data.utagDL;
                                        tealiumEvent(stepVal,eventName);
                                    }
                                }
                            });
                        }
                    }else{
                    	stepVal = "0";
                    	eventName = 'login-failure';
                    	tealiumEvent(stepVal,eventName);
                        validator.settings.errorClear($('.login-form .spc-login-btn'));
                        var $loginForm = $(document.getElementsByClassName('login-form'));
                        if(window.lastClickOrKey === 'key'){
                            $loginForm.find('.form-row.username .input-text.email').addClass('focus-outline').focus().select();
                        }
                        $loginForm.find('.form-row.username .input-text.email,.form-row.password .input-text.password').addClass('email-login-failure');

                        $('body').off('input','.login-form .form-row.password .input-text.password,.login-form .form-row.username .input-text.email').on('input','.login-form .form-row.password .input-text.password,.login-form .form-row.username .input-text.email',function(){
                            $loginForm.find('.form-row.username .input-text.email,.form-row.password .input-text.password').removeClass('email-login-failure');
                        });
                        $('body').off('keydown keypress click mousedown','.login-form .spc-login-btn').on('keydown keypress click mousedown','.login-form .spc-login-btn', function (e) {
                            if((e.keyCode && e.keyCode == 13)){
                                util.validateLoginOnSubmit($loginForm);
                            }
                        });
                        $('body').off('blur').on('blur','.login-form .form-row.username .input-text.email', function (e) {
                            util.validateEmailOnFocusOut($loginForm);
                        });
                        $('body').off('blur').on('blur','.login-form .form-row.password .input-text.password', function (e) {
                            util.validatePasswordOnFocusOut($loginForm);
                        });
                        var $chkoutGuestLoginForm = $('.checkout-tabs .checkoutlogin .guest-form');
                        $('body').off('keydown keypress click mousedown','.checkout-tabs .checkoutlogin .guest-form .checkout-guest-btn button').on('keydown keypress click mousedown','.checkout-tabs .checkoutlogin .guest-form .checkout-guest-btn button', function (e) {
                            if((e.keyCode && e.keyCode == 13)){
                            	 util.checkoutGuestSignInFocus($chkoutGuestLoginForm);
                            }
                        });
                        $('body').off('blur','.checkout-tabs .checkoutlogin .guest-form input.input-text').on('blur','.checkout-tabs .checkoutlogin .guest-form input.input-text', function (e) {
                     	   util.validateGuestEmailOnFocusOut($chkoutGuestLoginForm);
                        });
                        $('body').off('input','.checkout-tabs .checkoutlogin .guest-form input.input-text').on('input','.checkout-tabs .checkoutlogin .guest-form input.input-text', function() {
                        	$chkoutGuestLoginForm.find('.username-checkout-guest, .emailValidCheckoutGuest').addClass('hide');
                    	});
                    }
                    if($(".checkout-tabs").hasClass("spc-express-checkout")) {	//If express checkout
        				if(!$(".ui-dialog").is(":visible")) {
        					if($('.checkout-tab-head.open').length) {
        						if ($('.carddetails.selected').hasClass('plcccard')) {
        							$('html, body').animate({ scrollTop: $('.checkout-tab-head.open').offset().top - $('.pt_checkout #header').outerHeight() - 12 }, 700);
        						} else {
        							$('html, body').animate({ scrollTop: $('.card-list').find('.carddetails.selected').offset().top - $('.pt_checkout #header').outerHeight() - 12 }, 700);
        						}
        					}
        				}
            		} else {
            			scrollToActiveTab();
            		}
                }
            	if($('.login-box-content.returning-customers').length>0 && $('.returning-customers .invalid-email').length>0 && $('.returning-customers .customerFound').length>0 && $('.returning-customers .customerFound').val()=='true'){
            		localStorage.setItem('emailSubmitted',$('.login-box-content.returning-customers .input-text.email.required.email').val());
            	}
            	 // SM-6687 Load new Tealium Information after User Authentication on Checkout.
            	/** retrigger tealium utag javascript sources to create the cookie and tealium related attributes in utag_data datalayer**/
                if(typeof utag_data != 'undefined'){
                    buildDataLayerTealium();
                }

            }

        });

    });

    function buildDataLayerTealium() {
    	 $('.tealium-data').load(Urls.tealiumData, function () {});
    }

    $cache.primary.on('click', '.spc-guest-btn:not(:disabled)', function (e) {
        e.preventDefault();
        var form = $(this).closest('form'),stepVal = '', eventName = '', registrationType = "";
        $('<input type="hidden" name="' + $(this).attr('name') + '" value="true" />').appendTo(form);
        var addToEmailList = $(this).closest('form').find('input[name$=_addToEmailList]').is(':checked');
        if ($('.guest-form').valid()) {
            $('body').find('#username-checkout-guest-req-error').addClass('hide');
        } else {
            $('body').find('#username-checkout-guest-req-error').removeClass('hide');
        }
        if(!($('.guest-form .emailAddress .email').val())) {
            $('body').find('#username-checkout-guest-req-error').removeClass('hide');
        } else {
            $('body').find('#username-checkout-guest-req-error').addClass('hide');
        }
        form.validate();
        if (!form.valid()) {
            return false;
        }
        var data = form.serialize();
        $('input[type=checkbox]').each(function() {
            if (!this.checked) {
                data += '&'+this.name+'=false';
            }
        });
		/* SC-11124, To track Guest SMS Optin experience1 vs experience2 */
		if(util.getCookie('guestsmsoptin') == ""){
			if($(this).closest('form').find('input[name$=_smsSignUp]').length > 0 && $(this).closest('form').find('input[name$=_smsSignUp]').is(':visible')) {
				/* Experience2 cookie tracking */
				var smsSubscription = $(this).closest('form').find('input[name$=_smsSignUp]').is(':checked');
				var name = 'guestsmsoptin', value='';
				value = 'login_method'+ '|' + smsSubscription + '|' + 'false';
				document.cookie = name+'='+value+'; path=/;secure';
			} else {
				/* Experience1 cookie tracking */
				var name = 'guestsmsoptin', value='';
				value = 'shipping_details'+ '|' + 'false' + '|' + 'false';
				document.cookie = name+'='+value+'; path=/;secure';
			}
		}
		/* SC-11124, To track Guest SMS Optin experience1 vs experience2 */
        progress.show($cache.main);
        ajax.load({
            url: form.attr('action'),
            data: data,
            method: 'POST',
            callback: function (data) {
                var isJson = isValidJson(data);
                if (isJson) {
                    var validJSON = JSON.parse(data);
				    if (validJSON.isCountryMisMatchError === true) {
					    window.location = validJSON.redirectUrl;
				    }
                }
                $cache.primary.html(data);
                handleBasketError();
                initSPC();
                validator.init();
                if($('body').find('.existing-user-email').length) {
                    $('body').find('.guest-form .emailAddress').addClass('error-handle');
                    validator.settings.errorPlacement('<span class="error">Invalid Email Address</span>',$('body').find('.guest-form .emailAddress input'));
                    $('body').find('.guest-form .emailAddress input').addClass('error');
                    var obj = {};
                    obj.event_name = 'guest_checkout_account_already_exists';
                    tealium.triggerEvent(obj);
                }
                if ($cache.primary.find('.spc-login').length === 0) {
                    tooltip.init();
                    util.limitCharacters();
                    checkout.init();
                }
                $('.header-mian-banner').find('.checkout-progress-indicator').html($('.checkoutinfo').find('.checkout-progress-indicator').html());
                if ($cache.primary.find('.spc-billing.giftcard-only').length > 0) {
                	updateSummary(2)
                }
                progress.hide();
                updateAnchor();
                $('body').find('#username-checkout-guest-req-error').addClass('hide');
                if(!($('.guest-form .emailAddress .email').val())) {
                    $('body').find('#username-checkout-guest-req-error').removeClass('hide');
                } else {
                    $('body').find('#username-checkout-guest-req-error').addClass('hide');
                }
                if ($cache.primary.find('.spc-login').length === 0) {
                	if($('.header-mian-banner').find('.checkout-progress-indicator .active .progress-count').length == 1){
                    	stepVal = $('.header-mian-banner').find('.checkout-progress-indicator .active .progress-count').text();
                	}
                    if($('body').find('.registrationType').length && $('body').find('.registrationType').val() == 'optional') {
                        registrationType = 'checkout_optional_account_creation';
                    } else if($('body').find('.registrationType').length && $('body').find('.registrationType').val() == 'mandatory') {
                        registrationType = 'checkout_required_account_creation';
                    }
                    tealiumEvent(stepVal,eventName,registrationType,addToEmailList);
                }else{
                	stepVal = "0";
                	tealiumEvent(stepVal,eventName);
                	tealiumAddToEmailListEvent(addToEmailList,eventName); // SM-2013 Trigger AddToEmailListEvent.
                }
                scrollToActiveTab();
            }
        });
    });
}

function isValidJson(str) {
    try {
        JSON.parse(str);
    } catch (e) {
       return false;
    }
    return true;
}

function loadSPCShipping() {
    window.enterKeyCheckoutFormSubmit = window.lastClickOrKey === 'key' ? true : false ;
    $cache.primary.off('click touchstart', '.spc-shipping-btn').on('click touchstart', '.spc-shipping-btn', function (e) {
        var self = this;
        e.preventDefault();
        var addrees1 = $('.address').find('input[name$="_addressFields_address1"]').val();
        var addrees2 = $('.address').find('input[name$="_addressFields_address2"]').val();
        var isExcludedProducts = $('.po-exclude-products').val();
        var hemmingProducts = $('.shippingmethod-exception').data("prodid");
        var exclusionValues = SitePreferences.POBOX_EXCLUSIONS;
        var isExclusion = false;
        if (isExcludedProducts == 'true' && exclusionValues != undefined && exclusionValues != null && exclusionValues != '') {
        	var exclusionList = exclusionValues.split(',');
	    	for (var i=0;i<exclusionList.length; i++ ) {
	    		var restrictedAddress = exclusionList[i].toLowerCase();
	    		addrees1 = addrees1.toLowerCase();
	    		if (addrees1.indexOf(restrictedAddress) >= 0) {
	    			isExclusion = true;
	    			break;
	    		}
	    	}
	    	if (!isExclusion && addrees2 != undefined && addrees2 != null && addrees2 != '') {
	    		for (var i=0;i<exclusionList.length; i++ ) {
	    			var restrictedAddress = exclusionList[i].toLowerCase();
    	    		addrees2 = addrees2.toLowerCase();
    	    		if (addrees2.indexOf(restrictedAddress) >= 0) {
    	    			isExclusion = true;
    	    			break;
    	    		}
    	    	}
	    	}
	    }
    	if (isExclusion) {
    		dialog.open({
	            url: Urls.poExclusion,
	            options: {
                    dialogClass: "checkout-pobox-smexception",
	                open: function () {
	                	$('.edit-shipping').on('click',function(e){
	                		dialog.close();
	                		$('.shipping-add-edit').trigger('click'); //SM-6697
	                	});
	                	$('.apply-slim-scrollbar').slimScroll({
	                        height: $(window).width() < 768 ? "253px" : "193px",
	                        railVisible: true,
	                        color: "#000000",
	                        railOpacity: 1,
	                        size: '10px',
	                        railColor: "#e5e5e5",
	                        alwaysVisible: true
	                    });
	                	$('.remove-tems').on('click',function(e){
	                		e.preventDefault();
	            	        var form = $(this).closest('form');
	            	        $('<input type="hidden" name="' + $(this).attr('name') + '" value="true" />').appendTo(form);
	            	        form.validate();
	            	        if (!form.valid()) {
	            	            return false;
	            	        }
	            	        ajax.load({
	            	            url: form.attr('action'),
	            	            data: form.serialize(),
	            	            method: 'POST',
	            	            callback: function (data) {
	            	            	dialog.close();
	            	            	var $summary = $('#secondary .checkout-order-summary-container');
	            	            	$summary.html($(data).filter('.minisummary').html());
	    	            	        $summary.fadeIn('fast');
	    	            	        $summary.find('.checkout-mini-cart .minishipment .header a').hide();
	    	            	        $summary.find('.order-totals-table .order-shipping .label a').hide();
		            		        $summary.find('.rightbutton').on('click',function(){
		            		        	$('#primary').find('.spc-shipping-btn').trigger('click');
		            		    	});
		            		        $('.basket-details').html($(data).filter('.basketinfo').html());
		            		        $('.po-exclude-products').val('false');
		            		        shipping.updateShippingMethodList();
	            	            }
	            	        });
	                	});

	                	/* PXSFCC-4495_WCAG_Modal_focus_management */
	                	$(".ui-dialog").find(".ui-dialog-titlebar-close").on("mouseenter",function(){
	                    	$(this).focus();
	                    });
	                    $(".ui-dialog").find(".ui-dialog-titlebar-close").trigger("mouseenter");
	                }
	            }
	        });
	    	return false;
	    }

        var selectedShipMethod = $('input[name$="_shippingMethodID"]:checked').closest('.ship-exception').find('.shipping-method-name').val();
        var defaultShipMethod = $('.default-ship-method-name').val();
        var proceedAfterHemmingExclusionAccepted  = true;

        if(hemmingProducts !== undefined && hemmingProducts.length > 0 && selectedShipMethod != defaultShipMethod && MERCH_UTILS.getCookie('_hemmingExclusionModal') != 'true'){

            var url = Urls.shipExclusion;
            url = util.appendParamsToUrl(url, {
                prodID: hemmingProducts,
                selectedShipMethod : selectedShipMethod,
                defaultShipMethod : defaultShipMethod
            });

            dialog.open({
	            url: url,
	            options: {
	                open: function () {
	                	$('.edit-shipping').on('click',function(e){
	                		dialog.close();
	                		$('.shipping-add-edit').trigger('click'); //SM-6697
	                	});
	                	$('.apply-slim-scrollbar').slimScroll({
	                        height: $(window).width() < 768 ? "253px" : "193px",
	                        railVisible: true,
	                        color: "#000000",
	                        railOpacity: 1,
	                        size: '10px',
	                        railColor: "#e5e5e5",
	                        alwaysVisible: true
	                    });

                        $('body').off('click','.cancel-ship-method-except').on('click','.cancel-ship-method-except',function(e){
                            var url = Urls.updateShipException;
                            util.removeCookie("_hemmingExclusionModal");
                            url = util.appendParamsToUrl(url, {
                                shippingException : false
                            });
                            ajax.load({
                                url: url,
                                callback: function (data) {
                                    var smlUrl = Urls.basketUpdaeteList;
                                    var $basketList = $('#cart-table');
                                    $basketList.load(smlUrl);
                                }
                            });
                            dialog.close();
                            $('.default-ship-method').prop('checked', true);
                            $('[name$="_shippingMethodID"]:checked').trigger('click');
                        });
                        $('body').off('click','.ship-method-submit').on('click','.ship-method-submit',function(e){
                            proceedAfterHemmingExclusionAccepted = true;

                            var url = Urls.updateShipException;
                            url = util.appendParamsToUrl(url, {
                                prodID: hemmingProducts,
                                shippingException : true
                            });
                            ajax.load({
                                url: url,
                                callback: function (data) {
                                    var smlUrl = Urls.basketUpdaeteList;
                                    var $basketList = $('#cart-table');
                                    $basketList.load(smlUrl);
                                }
                            });
                            dialog.close();
                            submitCheckoutStep1(self);
                        });
	                	/* PXSFCC-4495_WCAG_Modal_focus_management */
	                	$(".ui-dialog").find(".ui-dialog-titlebar-close").on("mouseenter",function(){
	                    	$(this).focus();
	                    });
                        $(".ui-dialog").find(".ui-dialog-titlebar-close").trigger("mouseenter");

	                }
	            }
            });
            //track if hemming exclusion modal was open
            MERCH_UTILS.setCookie("_hemmingExclusionModal", "true");
            proceedAfterHemmingExclusionAccepted = false;
        }

        if(proceedAfterHemmingExclusionAccepted) {
            submitCheckoutStep1(this)
         }

    });
    if($('.payPalshippingError').length > 0 && $('.payPalshippingError').val() === 'true') {
		$('#primary').find('.spc-shipping-btn').trigger('click');
	}
    /* Below method will show Q&A section of Shipping Section */
    util.showQuestionAndAnwser('shipping-questions');

    $('#secondary').find('.rightbutton').on('click',function(){
    	$('#primary').find('.spc-shipping-btn').trigger('click');
	});

    require('./pages/checkout/address').init();
}

function submitCheckoutStep1(step1Form){
        $(".validate-shipping-warn").addClass('hide');
        //remove cookie hemming modal cookie
        util.removeCookie("_hemmingExclusionModal");
        var checkoutRegisteredUser = false;
        var form = $(step1Form).closest('form'), stepVal = '', eventName ='';

        $('<input type="hidden" name="' + $(step1Form).attr('name') + '" value="true" />').appendTo(form);
        form.validate();
        if (!form.valid()) {
            var $errorElement=form.find('input.error,select.error').first();
            $errorElement.focus();
            formPrepare.completeFormMessage();
            if ($(window).width() < 768) {
            $('html, body').animate({
                scrollTop: $errorElement.offset().top - 95
            }, 200);
            }
            return false;
        }
        var data = form.serialize();
        // SM-3284, replacing encoded form of enter key(%0D%0A) with space value(+) in the giftMessage text field.
        if (data.indexOf('%0D%0A') > -1) {
            data = data.replace(/%0D%0A/g, "+");
        }
        //PXSFCC-1871
        if( $('input[name$="_makeDefaultAddress"]').prop('checked') ){
            if (data.indexOf(form.find('.form-row.addToAddressBook input').attr('name')) == -1) {
                data = data + "&" + form.find('.form-row.addToAddressBook input').attr('name') + '=' + form.find('.form-row.addToAddressBook input').val();
            }
        }
        data += "&spc_shipping_continue=true";
        var isPerkInCart = $('.is-perks-fee-already-in-cart').val();
        data += "&isperksincart=" + isPerkInCart;

        progress.show($cache.main);
        ajax.load({
            url: form.attr('action'),
            data: data,
            method: 'POST',
            callback: function (data) {
                var isJson = isValidJson(data);
                if (isJson) {
                    var validJSON = JSON.parse(data);
				    if (validJSON.isCountryMisMatchError === true) {
					    window.location = validJSON.redirectUrl;
				    }
                }
                $cache.primary.html(data);
                if($(data).find('.checkoutRegisteredUser').length > 0){
                    var value = $(data).find('.checkoutRegisteredUser').val();
                       if(value === 'true'){
                         checkoutRegisteredUser = true;
                       }
                 }
                
                handleBasketError();
                var stepCount = 2;
                if ($(data).find('.spc-shipping-btn').length > 0) {
                    stepCount = 1;
                    require('./pages/checkout/shipping').init();
                }
                if($cache.primary.find('.spc-express-checkout').length > 0) {
                    stepCount = 3;
                    util.updateselect();
                    require('./pages/checkout/billing').init();
                    loadExpressCheckout();
                    // Scroll to the Order review section
                    $('html, body').animate({ scrollTop: $('.checkout-tab-head.open').offset().top - $('.pt_checkout #header').outerHeight() - 12 }, 700);
                } else {
                    updateSummary(stepCount);
                }
                initSPC();
                util.updateselect();
                tooltip.init();
                util.limitCharacters();
                validator.init();
                require('./addressvalidation').init();
                if($('#address-validation-dialog').length == 0){
                    checkout.init();
                }
                $('.header-mian-banner').find('.checkout-progress-indicator').html($('.checkoutinfo').find('.checkout-progress-indicator').html());
                if(checkoutRegisteredUser){
                    // on checkout register slas creates new session id so existing csrf token becomes invalid. so we setting a new csrf token
                    refreshCSRFToken();
                }
              
                progress.hide();
                if ($cache.primary.find('.spc-shipping').length === 0) {
                    updateAnchor();
                    if($('.header-mian-banner').find('.checkout-progress-indicator .active .progress-count').length == 1){
                        stepVal = $('.header-mian-banner').find('.checkout-progress-indicator .active .progress-count').text();
                    }
                    tealiumEvent(stepVal,eventName);
                } else {
                    updateAnchor(true);
                    if($('#address-validation-dialog').length == 0){
                        stepVal = '1';
                        tealiumEvent(stepVal,eventName);
                    }
                }
                updateUtagDataInCheckout();
                /*if(!$(".ui-dialog").is(":visible")) {
                    scrollToActiveTab();
                }*/
                if(!$('#address-validation-dialog').is(':visible')){
                    var prescreenData = $(data).find('.eds-customer-prescreened').data();
                    var rtpsForm = null;
                    if(form.find('input[name$="_useAsBillingAddress"]').val() === 'true'){
                        rtpsForm = form;
                    }else if($("#dwfrm_billing").find('input.firstName').val() !== ''){
                        rtpsForm = $("#dwfrm_billing");
                    }
                    if(!(prescreenData && prescreenData.screened === true) && rtpsForm){
                        $('.eds-rtps-data').trigger('click');
                        EDSPrescreen.submitRTPS(formToBuyer(rtpsForm), 'checkout');
                    }
                }
            }
        });
}

function loadSPCBilling() {
	window.enterKeyCheckoutFormSubmit = window.lastClickOrKey === 'key' ? true : false ;
    if($('body').find('.registrationType').length && $('body').find('.registrationType').val() == 'optional') {
        var obj = {};
        obj.event_name = 'checkout_optional_account_creation';
        tealium.triggerEvent(obj);
    } else if($('body').find('.registrationType').length && $('body').find('.registrationType').val() == 'mandatory') {
        var obj = {};
        obj.event_name = 'checkout_required_account_creation';
        tealium.triggerEvent(obj);
    }
	 require('./pages/checkout/billing').init();
	 initCredit();
	 require('./pages/checkout/address').init();
	 $cache.primary.off('click touchstart', '.spc-saveAddr-btn').on('click touchstart', '.spc-saveAddr-btn', function (e) {
		e.preventDefault();
        var checkoutRegisteredUser = false;
        var form = $(this).closest('form');
        $('<input type="hidden" name="' + $(this).attr('name') + '" value="true" />').appendTo(form);
        form.validate();
        if (!form.valid()) {
            var $errorElement=form.find('input.error,select.error').first();
            $errorElement.focus();
            formPrepare.completeFormMessage();
            if ($(window).width() < 768) {
            $('html, body').animate({
                scrollTop: $errorElement.offset().top - 95
            }, 200);
            }
            return false;
        }
        var actionURL = form.attr('action');
        actionURL = util.appendParamToURL(actionURL, 'action', 'update');
        progress.show($cache.main);
        ajax.load({
            url: actionURL,
            data: form.serialize(),
            method: 'POST',
            callback: function (data) {
                var isJson = isValidJson(data);
                if (isJson) {
                    var validJSON = JSON.parse(data);
				    if (validJSON.isCountryMisMatchError === true) {
					    window.location = validJSON.redirectUrl;
				    }
                }
                    $(".validate-shipping-warn").addClass('hide');
                    $cache.primary.html(data);
                    if($(data).find('.checkoutRegisteredUser').length > 0){
                       var value = $(data).find('.checkoutRegisteredUser').val();
                          if(value === 'true'){
                            checkoutRegisteredUser = true;
                          }
                    }
                    handleBasketError();
                    initSPC();
                    validator.init();
                    if ($cache.primary.find('.spc-login').length === 0) {
                        tooltip.init();
                        util.limitCharacters();
                        checkout.init();
                    }
                    $('.header-mian-banner').find('.checkout-progress-indicator').html($('.checkoutinfo').find('.checkout-progress-indicator').html());
                    if(checkoutRegisteredUser){
                        // on checkout register slas creates new session id so existing csrf token becomes invalid. so we setting a new csrf token
                        refreshCSRFToken();
                    }
                    progress.hide();
                    updateSummary(2);
                    scrollToActiveTab();
                    updateUtagDataInCheckout();
                    formPrepare.init({
                        formSelector: 'form[id$="billing"]',
                        continueSelector: '[name$="billing_save"],[name$="submit_form"],[name$="_billing_saveAddress"]'
                    });
                    var prescreenData = $(data).find('.eds-customer-prescreened').data();
                    if(!(prescreenData && prescreenData.screened === true)){
                        $('.eds-rtps-data').trigger('click');
                        EDSPrescreen.submitRTPS(formToBuyer(form), 'checkout');
                    }
                }
            });
	});

     $('.creditcardnumber input,.cvn input:visible').on('input change',function(){
        util.allowDigits($(this));
    });

	 $('.cvn input:visible').on('blur',function(){
		 $('.cvn input').not(":visible").val($('.cvn input:visible').val());
	 });

	 /* Below method will show Q&A section of Billing Section */
	 util.showQuestionAndAnwser('billing-questions');

	 $cache.primary.off('click', '.editcard').on('click', '.editcard', function (e) {
        e.preventDefault();

        var form = $(this).closest('form');
        $('<input type="hidden" name="' + $(this).attr('name') + '" value="true" />').appendTo(form);
        form.validate();
        if (!form.valid()) {
            return false;
        }
        var actionURL = form.attr('action');
        actionURL = util.appendParamToURL(actionURL, 'action', 'update');
        progress.show($cache.main);
        ajax.load({
            url: actionURL,
            data: form.serialize(),
            method: 'POST',
            callback: function (data) {
            	$cache.primary.html(data);
                handleBasketError();
                initSPC();
                validator.init();
                if ($cache.primary.find('.spc-login').length === 0) {
                    tooltip.init();
                    util.limitCharacters();
                }
                $('.header-mian-banner').find('.checkout-progress-indicator').html($('.checkoutinfo').find('.checkout-progress-indicator').html());
                progress.hide();
                updateSummary(2);
            	formPrepare.init({
                    formSelector: 'form[id$="billing"]',
                    continueSelector: '[name$="billing_save"],[name$="submit_form"],[name$="_billing_saveAddress"]'
                });
            }
        });
 	});

	 $cache.primary.off('click touchstart', '.spc-billing-btn').on('click touchstart', '.spc-billing-btn', function (e) {
	    window.enterKeyCheckoutFormSubmit = window.lastClickOrKey === 'key' ? true : false ;
        if (($('input[name$=_selectedPaymentMethodID]:checked').val() === 'PayPal' || $('input[name$=_selectedPaymentMethodID]:checked').val() === 'PayPalPayLater') && $('.spc-billing-btn').attr('id') != '' && $('.spc-billing-btn').attr('id') != 'null' ) {
            $(this).removeClass('spc-billing-btn');
            return true;
        }

        e.preventDefault();
        var stepVal = '',eventName='';
        var form = $(this).closest('form');
        $('<input type="hidden" name="' + $(this).attr('name') + '" value="true" />').appendTo(form);

        form.validate();
        if (!form.valid()) {

        	var $errorElement=form.find('input.error,select.error').first();
        	$errorElement.focus();
        	formPrepare.completeFormMessage();
        	if ($(window).width() < 768) {
        	 $('html, body').animate({
        		 scrollTop: $errorElement.offset().top - 95
             }, 200);
        	}
        	//Fix for error handle class not adding on click
        	var $elementsErrorSelect=form.find(".billingfields").find('.form-row.month, .form-row.year');
        	if(!$elementsErrorSelect.hasClass('error-handle') && !$elementsErrorSelect.find('select').val()){
        		$elementsErrorSelect.addClass('error-handle');
        	}
            return false;
        }
        var data = form.serialize();
        //PXSFCC-4491
        if (data.indexOf(form.find('.form-row.saveCard input').attr('name')) == -1) {
        	data = data + "&" + form.find('.form-row.saveCard input').attr('name') + '=' + form.find('.form-row.saveCard input').val();
        }

        var cardType = '';
        if(form.find('select[id$=_creditCard_type]').length > 0 ){
        	cardType = form.find('select[id$=_creditCard_type]').val().toLowerCase();
        }
    
        progress.show($cache.main);
        ajax.load({
            url: form.attr('action'),
            data: data,
            method: 'POST',
            callback: function (data) {
                var isJson = isValidJson(data);
                if (isJson) {
                    var validJSON = JSON.parse(data);
				    if (validJSON.isCountryMisMatchError === true) {
					    window.location = validJSON.redirectUrl;
				    }
                }
                $cache.primary.html(data);
                handleBasketError();
                if ($(data).find('.checkout-billing').length >= 1) {
                	updateSummary(2);
                    var eventData = {}

                    if ($(data).find("input[name='service_response_code']").length === 1) {
                        eventData.service_response_code = $(data).find("input[name='service_response_code']").val();
                    }

                    if ($(data).find("input[name='avs_response_code']").length === 1) {
                        eventData.avs_response_code = $(data).find("input[name='avs_response_code']").val();
                    }

                    if ($(data).find("input[name='cvv_match_code']").length === 1) {
                        eventData.cvv_match_code = $(data).find("input[name='cvv_match_code']").val();
                    }

                    eventData.event_name = "error_form";
                	eventData.error_form_response = "checkout:payment information or billing:"+cardType;
					tealium.triggerEvent(eventData);
                } else {
                    updateSummary(3);
                }
                initSPC();
                if ($cache.primary.find('.spc-summary').length === 0) {
                    tooltip.init();
                    util.limitCharacters();
                    validator.init();
                }
                checkout.init();
                $('.header-mian-banner').find('.checkout-progress-indicator').html($('.checkoutinfo').find('.checkout-progress-indicator').html());
              
                progress.hide();
                if ($cache.primary.find('.spc-billing').length === 0) {
                    updateAnchor();
                } else {
                    updateAnchor(true);
                }

                $cache.secondary.find('.rightbutton').on('click',function(){
            		$('.submit-order button').trigger('click');
            	});
                $('.button-fancy-large.rightbutton.final-submit').removeAttr("disabled");
                if($('.header-mian-banner').find('.checkout-progress-indicator .active .progress-count').length == 1){
            		stepVal = $('.header-mian-banner').find('.checkout-progress-indicator .active .progress-count').text();
            	}
                $('input[name$="_creditCard_makeDefault"]').trigger('change');
                tealiumEvent(stepVal,eventName);
            }
        });
    });

    $cache.primary.off('click touchstart', '.selectpaymentmethod').on('click touchstart', '.selectpaymentmethod', function (e) {
    	e.preventDefault();
        var $checkoutForm = $('.checkout-billing');
        if (!$checkoutForm.valid()) {

        	var $errorElement=$checkoutForm.find('input.error,select.error').first();
        	$errorElement.focus();
        	formPrepare.completeFormMessage();
        	if ($(window).width() < 768) {
        	 $('html, body').animate({
        		 scrollTop: $errorElement.offset().top - 95
             }, 200);
        	}
        	return false;
        }
    });

    // add generic toggle functionality
    $cache.primary.find('.toggle').next('.toggle-content').hide();
    $cache.primary.find('.toggle').click(function() {
    	// removed handling of billing page tabs, working from generic code
     	 $(this).toggleClass('expanded').next('.toggle-content').slideToggle();
    });
    if ($('.billing-coupon-code ').is(':visible')) {
 		$('.showcontent').find('.toggle').addClass('expanded');
    }

    if($('.row-header').closest('.tab-section.showcontent').find('.toggle-content').is(':visible')) {
        $('.row-header').closest('.tab-section.showcontent').find('.arrow-img').addClass('expanded');
    }

    $cache.primary.find('.editsection').click(function() {
    	$cache.primary.find('.spc-saveAddr-btn').trigger('click');
		});

		$cache.primary.find('.editsection').keypress(function() {
    	$cache.primary.find('.spc-saveAddr-btn').trigger('click');
    });

    $cache.primary.off("click keypress", ".newsection .addaddress,.newsection .editaddress").on("click keypress", ".newsection .addaddress,.newsection .editaddress", function(e) {
			if(!e.isTrigger && e.which != 1 && e.which != 13 ){
				return;
			}
			if ($(this).hasClass('addaddress')) {
				$('select[name$="_addressList"]').val('').trigger('change');
				if (!$('.fieldsection').is(':visible')) {
					$('.fieldsection .state select').val('').trigger('change');
					$('.fieldsection input.input-text').val('');
					$('.fieldsection').toggle();
				}
		} else {
			$('.fieldsection').toggle();
			$('.addresssection').addClass('editing');
		}
		$('.checkout-billing .saved-address-block .required-field').removeClass('hide');

    	$("#primary .required-fields-warn,#secondary .required-fields-warn").addClass('hide');
    	util.newCreditCardTriggered = false;
    	$('.selecteddetails .addresssection').addClass('content-hide');
    	$('.saved-addr-dropdown-section .select-address').removeClass('hide');
    	if (!$(this).hasClass('addaddress')) {
    		$('.savesection,.actionsection').toggle();
    		util.selectbox();
    	}
    	$('.selectpayment').addClass('hide');
    	formPrepare.init({
            continueSelector: '[name$="selectpaymentmethod"],[name$="submit_form"],[name$="_billing_saveAddress"]',
            formSelector: 'form[id$="billing"]'
        });
    });
    $cache.primary.off('click','.newcreditcard').on('click','.newcreditcard',function() {
        window.newCardClicked = true;
    	if ($('#is-PayPal').is(':checked')){
    		util.newCardFlag = true;
    		$('#is-CREDIT_CARD').trigger('click');
    		$(this).closest('.selectpayment').removeClass('paypal-selected');
    		$('.carddetails.paypal-selected').removeClass('paypal-selected');
    		$('.cvninfo.paypal-selected').addClass('selected').removeClass('paypal-selected').removeClass('hide');
    		$('.cvninfo.selected div.cvn:visible').closest('.cardinfo').find('.carddetails').addClass('selected');
    		$('.cvninfo.selected div.cvn:visible,.cvninfo.selected input.cvn:visible').addClass('required');
    		if($('.cvninfo.selected div.cvn:visible,.cvninfo.selected input.cvn:visible').find('.required-indicator').length <=0){
    			$('.cvninfo.selected div.cvn:visible,.cvninfo.selected input.cvn:visible').find('label').append('<span class="required-indicator"> * </span>');
    		}
            $('.spc-billing-btn span').not(".disabled-hover-event").text(Resources.CHECKOUT_CONTINUE);
    		setTimeout(function () {
                $('.billingfields').removeClass('hide');
                $('.payment-method .billingfields input').val('');
        		$('.payment-method .billingfields select').val('').trigger('change');
                formPrepare.init({
                    continueSelector: '[name$="billing_save"],[name$="submit_form"],[name$="_billing_saveAddress"]',
                    formSelector: 'form[id$="billing"]'
                });
            },400);
    	} else {
    		$('.payment-method .billingfields input').val('');
    		$('.payment-method .billingfields select').val('').trigger('change');
            var $saveCard = $('input[name$="_creditCard_saveCard"]');
            $saveCard.prop('disabled', false);
    		$('.billingfields').removeClass('hide');
    	}
    	$(this).hide();
    	$('.cardinfo .carddetails.selected').removeClass('selected').addClass('changed');
    	$('.cardinfo .cvninfo.selected').addClass('hide');
    	$('.differed-billing .selected').addClass('changed hide');
        $('.cardinfo .cvninfo .form-row.cvn .form-caption ').removeClass('error-message').text('');
        $('.cardinfo .cvninfo .form-row.cvn').removeClass('error');
        $('.billingfields .error-message').text('').hide();
        $('.billingfields input').val('').removeClass('error');
        $('.billingfields select').removeClass('error');
        $('.billingfields label span.error').text('');
        $('.billingfields .form-row').removeClass('error-handle');
        $('input[name="cardSelected"]').val("false");
        $('input[name$="_creditCard_saveCard"]').prop('checked', false);	// This is required to uncheck the savecard checkbox
        $('input[name$="_creditCard_saveCard"]').val("false");
        $('input[name$="_creditCard_makeDefault"]').prop('checked', false);	// This is required to uncheck the deafault card checkbox
        $('input[name$="_creditCard_makeDefault"]').val("false");
        $('.billingfields .cvn input').on('input change',function(){
        	$('.cardinfo .cvninfo.selected .cvn input').val($(this).val());
        });
        $('.cvninfo.selected').addClass('hide');
        $('.seleted-card').val('false');
        util.inputfocusEvent();

        // Backend values will be there, hence removing classes manually
    	$('.billingfields').find(".form-row").removeClass('show-text');
    	$('.billingfields').find(".form-row ").find("label").removeClass("input-focus");
    	//Remove Error message
        $("#primary .required-fields-warn,#secondary .required-fields-warn").addClass('hide');

    	var $formRowList = $('.checkout-billing').find(".billingfields .form-row").not(".type, .creditcardnumber, .save-cancel, .makeDefault, .saveCard, .differedBilling");
    	$formRowList.removeClass("hide");
    	$('.differed-billing').addClass('hide');
		$formRowList.find("input,select").removeClass("hide");
		$('.checkout-billing').find(".billingfields").find('.form-row.owner, .form-row.month, .form-row.year').addClass('required');
        $('.checkout-billing').find(".billingfields").find('.form-row.owner input,.form-row.month select,.form-row.year select').addClass('required');
        if($('.checkout-billing').find(".billingfields").find('.form-row.owner,.form-row.month,.form-row.year,.form-row.cvn').find('.required-indicator').length <= 0){
        	$('.checkout-billing').find(".billingfields").find('.form-row.owner,.form-row.month,.form-row.year,.form-row.cvn').find('label').append('<span class="required-indicator"> * </span>');
    	}
    });

    var $defaultAddress = $('input[name$="_makeDefault"]');
    $defaultAddress.on('change', function () {
    	var $addtoAddress = $('input[name$="_addToAddressBook"]');
		if($defaultAddress.prop('checked')) {
			$addtoAddress.prop('checked', true);
			$defaultAddress.val("true");
			$addtoAddress.prop('disabled', true);
		}
		if(!($defaultAddress.prop('checked'))) {
			$addtoAddress.prop('checked', false);
			$defaultAddress.val("false");
			$addtoAddress.prop('disabled', false);
		}
    });

    $cache.primary.off("click keypress", ".addresscancel").on("click keypress", ".addresscancel", function(e) {
			if(!e.isTrigger && e.which != 1 && e.which != 13 ){
				return;
			}
    	if ($('.selected-address').val() != null && $('.selected-address').val() != '' && $('.selected-address').val() != undefined && $('select[name$="_addressList"]').val() != null && $('select[name$="_addressList"]').val() != '' && $('select[name$="_addressList"]').val() != undefined) {
    		$('select[name$="_addressList"]').addClass('address-cancelled');		//SM-5462
    		$('select[name$="_addressList"]').val($('.selected-address').val()).trigger('change');
    		if ($('.fieldsection').is(':visible')) {
    			$('.fieldsection').toggle();
    		}
    	} else {
    		$('.fieldsection').toggle();
       }

        if($('.savedAddressCount').length > 0 && $('.savedAddressCount').val() === '0'){
            $('.address-dropdown, .saved-address-count').hide();
        }
    	var $form = $('.checkout-billing.address');
    	var selectedAddress = $('.billing-address-details').data('address');
    	var selected = null;
    	if (selectedAddress == undefined || selectedAddress == null) {
    		selected = $('select[name$="_addressList"]').children(':selected').first();
    		var defaultFlag = $('select[name$="_addressList"]').find('option[data-isdefault]').length;
    		if(defaultFlag) {
    			$('select[name$="_addressList"]').find('option').removeAttr("selected");
    			$('select[name$="_addressList"]').find('option[data-isdefault]').attr("selected","selected");
    			$('select[name$="_addressList"]').find('option[data-isdefault]').prop("selected",true);
    			util.selectbox();
    			selected = $('select[name$="_addressList"]').children(':selected').first();
    		}
    		selectedAddress = $(selected).data('address');
    	} else {
    		if ($('select[name$="_addressList"]').find('option[data-selectedoption]').length > 0) {
    			$('select[name$="_addressList"]').find('option[data-selectedoption]').siblings().removeAttr("selected");
        		$('select[name$="_addressList"]').find('option[data-selectedoption]').prop("selected",true);
        		util.selectbox();
        		selected = $('select[name$="_addressList"]').find('option[data-selectedoption]');
        		selectedAddress = $(selected).data('address');
    		}
    	}

    	if ( selected !== null && selected.length > 0 && $('.selecteddetails .addresssection').hasClass('content-hide')) {
    		$('.selecteddetails .addresssection').removeClass('content-hide');
    	}

    	util.fillAddressFields(selectedAddress, $form);

    	if ($(this).hasClass('sameaddress')) {
    		$('.selecteddetails .addresssection').removeClass('content-hide');
        	$('.saved-addr-dropdown-section .select-address').addClass('hide');
    	}
    	$('.addresssection.editing').removeClass('editing').removeClass('content-hide');
    	$('.selectpayment').removeClass('hide');
    	//Removing error field on cancel
    	$form.find('.form-row').removeClass('error-handle');
    	$form.find('input,select').removeClass('error');
    	$("#primary .required-fields-warn,#secondary .required-fields-warn").addClass('hide');

    	//PXSFCC-4511 On clicking the cancel button edit link is not displayed in the billing details section
    	if($('.savesection:visible').length > 0) {
    		$('.savesection,.actionsection').toggle();
    	}
    	$('.spc-saveAddr-btn').removeClass('editaddress addnewaddress');
        $('.checkout-billing .saved-address-block .required-field').addClass('hide');
    	formPrepare.init({
            continueSelector: '[name$="billing_save"],[name$="selectpaymentmethod"],[name$="submit_form"],[name$="_billing_saveAddress"]',
            formSelector: 'form[id$="billing"]'
        });
    });

    $cache.primary.on('click', '.redemption.giftcert a.remove', function (e) {
        e.preventDefault();
        progress.show($cache.main);
        var url = $(this).attr('href');
        ajax.load({
            url: url,
            data: {},
            method: 'GET',
            callback: function (data) {
                $cache.primary.html(data);
                handleBasketError();
                updateSummary(2);
                initSPC();
                tooltip.init();
                util.limitCharacters();
                validator.init();
                checkout.init();
                progress.hide();
            }
        });
    });

    $('body').off('change','.billingfields .differedBilling .input-checkbox').on('change','.billingfields .differedBilling .input-checkbox',function(e) {
    	if($(this).is(':checked')){
            $('.differed-billing-content ').removeClass('hide');
            $('.differed-billing-content').closest('.differed-billing').find('.input-checkbox').prop('checked',true)
    	} else {
            $('.differed-billing-content ').addClass('hide');
            $('.differed-billing-content').closest('.differed-billing').find('.input-checkbox').prop('checked',false)
    	}
    });

    //calling view more less in diferred blling
    var diferredbillingcharacters = 273;
    if($(window).width() < 767) {
    	diferredbillingcharacters = 178;
    }
    util.veiwmorelesswithellipse(diferredbillingcharacters);

    if($("select[name $='_billing_paymentMethods_creditCard_type']").find('option:selected').attr("plccType") == "true") {
    	var $form = $("select[name $='_billing_paymentMethods_creditCard_type']").closest(".billingfields");
    	var $formRowList = $form.find(".form-row").not(".type, .creditcardnumber, .save-cancel, .makeDefault, .saveCard, .differedBilling");
    		$formRowList.addClass("hide");
        	$formRowList.find("input,select").addClass("hide");
        	$form.find('.form-row.owner,.form-row.month,.form-row.year').removeClass('required');
        	$form.find('.form-row.owner input,.form-row.month select,.form-row.year select').removeClass('required');
        	$form.find('.form-row.creditcardnumber input').attr('minlength','16');
        	$form.find('.form-row.creditcardnumber input').attr('maxlength','16');
        	$form.find('.cvv-label').addClass("hide");
        	if($('.plccDeferEnabled').length>0 && $('.plccDeferEnabled').val()=="true" && !$('#is-PayPal').is(':checked')){
        		$('.couponsection').find('.couponcontent').addClass('deferactive');
        		if ($('.couponsection').find('.couponcontent').is(':visible')){
        			$('.couponsection').find('.couponcontent').css('display','flex');
        		}
        	}
    } else {
    	var $form = $("select[name $='_billing_paymentMethods_creditCard_type']").closest(".billingfields");
    	$form.find('.form-row.owner,.form-row.month,.form-row.year').addClass('required');
    	$form.find('.form-row.owner input,.form-row.month select,.form-row.year select').addClass('required');
    	if($form.find('.form-row.owner,.form-row.month,.form-row.year,.form-row.cvn').find('.required-indicator').length <= 0){
    		$form.find('.form-row.owner,.form-row.month,.form-row.year,.form-row.cvn').find('label').append('<span class="required-indicator"> * </span>');
    	}
    	$form.find('.form-row.creditcardnumber input').attr('maxlength','19');
    	$form.find('.form-row.creditcardnumber input').attr('minlength','1');
    	$form.find('.cvv-label').removeClass("hide");
    	$('.differed-billing').addClass('hide');
    	if($('.plccDeferEnabled').length>0 && $('.plccDeferEnabled').val() =="true"){
    		$('.couponsection').find('.couponcontent').removeClass('deferactive');
    		$('.differed-billing-content').addClass('hide');
    		var $deferCheckbox= $('.differedBilling input[type="checkbox"]');
            $deferCheckbox.val(false);
    		$deferCheckbox.prop('checked',false);
    		if ($('.couponsection').find('.couponcontent').is(':visible')){
    			$('.couponsection').find('.couponcontent').css('display','block');
    		}
    	}
        $('#plcc-min-length-error').addClass('hide');
    }

    $cache.secondary.find('.rightbutton').on('click',function(){
    	if ($cache.primary.find('.spc-saveAddr-btn').is(':visible')) {
    		$cache.primary.find('.spc-saveAddr-btn').trigger('click');
    	} else {
    		$cache.primary.find('.spc-billing-btn').trigger('click');
    	}
	});

    if ($('.feature-action').val() == 'payment') {
    	$cache.primary.find('.newcreditcard').trigger('click');
	} else if ($('.feature-action').val() == 'editaddress') {
		$cache.primary.find('.newsection .editaddress').trigger('click');
	} else if ($('.feature-action').val() == 'addaddress'){
		$cache.primary.find('.newsection .addaddress').trigger('click');
	}
    if ($('.paypaluser').val() == 'true') {
    	$('.spc-billing-btn').attr('id','');
    	$('.billing-cards-section').find('input[name$="_paypal_useAnotherAccount"]').on('change',function(){
    		if ($(this).is(':checked')) {
    			$('.spc-billing-btn').attr('id',$('.paypalsessionid').val());
    		} else {
    			$('.spc-billing-btn').attr('id','');
    		}
    	});
    }
}

function tealiumEvent(stepVal,eventName,registrationType,addToEmailList,isEdit, plccEdit) {
    var pageName = '';
    if (stepVal == 2){
        pageName = 'checkout: shipping_details';
        eventName = 'shipping_details';
    } else if(stepVal == 3) {
        pageName = 'checkout: payment_details';
        eventName = 'payment_details';
    } else if(window.utag_data && window.utag_data.page_type == 'confirmation') {
        if(window.utag_data.rendered_page === 'orderconfirmation'){
            pageName = "confirmation";
        } else {
            pageName = "maybeorderdetails";
        }
    }

    // update the event name page name when we click on edit button on specific step
    if (isEdit) {
        if (stepVal == 0 ) {
            pageName = 'checkout: login_details';
            eventName = isEdit ? 'edit_login_details' : 'login_details';
        } else if (stepVal == 1){
            pageName = 'checkout: shipping_details';
            eventName = isEdit ? 'edit_shipping_details': 'shipping_details';
        } else if(stepVal == 2) {
            pageName = 'checkout: payment_details';
            if (plccEdit) {
                eventName = isEdit ? 'edit_PLCC_payment_detail' : 'payment_details';
            } else {
                eventName = isEdit ? 'edit_payment_details' : 'payment_details';
            }
        } 
    }

	if( typeof(utag_data) != 'undefined' ) {
      	var obj = {
  			page_name : pageName != '' ? pageName : 'cart:'+stepVal,
  			product_id : utag_data.product_id,
  			product_sku : utag_data.product_sku,
            product_sku_adobe : utag_data.product_sku_adobe,
  			product_item_id : utag_data.product_item_id,
  			product_list_price : utag_data.product_list_price,
  			product_unit_price : utag_data.product_unit_price,
            product_quantity : utag_data.product_quantity,
            outlet_status: utag_data.outlet_status,
            step_name: stepVal
      	}
      	if( typeof(eventName) != 'undefined' && eventName!=null && eventName!= '' ){
      		obj.event_name = eventName;
      	}
        if( typeof(registrationType) != 'undefined' && registrationType != null && stepVal == 1 &&
        typeof(addToEmailList) != 'undefined' && addToEmailList != null && addToEmailList != ''){
            obj.event_name = utag_data.user_authenticated === "false" ? 'checkout_guest' : 'sign_in_checkout';
            obj.page_name = 'checkout:'+obj.event_name;
            obj.registrationType = registrationType;
            obj.deals_opt_in_out_response = addToEmailList;
            obj.is_promotable = addToEmailList ? "is_promotable" : "is_not_promotable";
            obj.deal_opt_in_out_location = utag_data.user_authenticated === "false" ? "Guest Checkout" : "Checkout Review";
            if(obj.is_promotable == 'is_promotable'){
                obj.primary_brand_email=utag_data.checkout_brand != "" ? (utag_data.checkout_brand).toUpperCase():"";
                var addToCartBrands=utag_data.add_to_cart_brand;
                if(addToCartBrands != null){
                    var brandArray=[];
                    for (var i=0;i<addToCartBrands.length;i++){
                        var brandValue=addToCartBrands[i].toUpperCase();
                        if(brandArray.indexOf(brandValue) == -1){
                            brandArray.push(brandValue);
                        }
                    }
                    obj.secondary_brand_email=brandArray;
                }
            }
        }
            tealium.triggerViewEvent(obj);
        }
  	}

//SM-2013 Trigger AddToEmailListEvent.
function tealiumAddToEmailListEvent(addToEmailList,eventName) {
	  if( typeof(utag_data) != 'undefined' ){
        var obj = {
            deals_opt_in_out_response : addToEmailList
        }
    	if ( typeof(eventName) != 'undefined' && eventName!=null && eventName!= '' ) {
      		obj.event_name = eventName;
        }
        tealium.triggerViewEvent(obj);
        // SC-1136: trigger new event which will only include event name and no data.
        obj = {};
        obj.event_name = addToEmailList ? "is_promotable" : "is_not_promotable";
        obj.deal_opt_in_out_location = utag_data.user_authenticated === "false" ? "Guest Checkout" : "Checkout Review";
        if(obj.event_name == 'is_promotable'){
	        obj.primary_brand_email=utag_data.checkout_brand != "" ? (utag_data.checkout_brand).toUpperCase():"";
	        var addToCartBrands=utag_data.add_to_cart_brand;
	        if(addToCartBrands != null){
	        	var brandArray=[];
	        	for (var i=0;i<addToCartBrands.length;i++){
	        		var brandValue=addToCartBrands[i].toUpperCase();
	        		if(brandArray.indexOf(brandValue) == -1){
	        			brandArray.push(brandValue);
	        		}
	        	}
	        	obj.secondary_brand_email=brandArray;
	        }
        }
        tealium.triggerViewEvent(obj);
	}
}

function updateSummary(stepCount) {
    var url = Urls.summaryRefreshURL;
    if (stepCount != null) {
    	url = util.appendParamToURL(url, 'stepCount', stepCount);
        $('#couponCheckoutStep').val(stepCount);
    }
    var summary = $('#secondary .checkout-order-summary-container');
    // adding timeout since load takes time and spinner we need to place
    setTimeout(function(){
        if (stepCount == 2 && !$(".secondary-content.summary").hasClass("loaded")) {
            progress.show($cache.main);
        }
    }, 500);
    summary.load(url, function () {
        $(".secondary-content.summary").addClass("loaded");
        // spinner stops as soon as load method done
        progress.hide();
        summary.find('.checkout-mini-cart .minishipment .header a').hide();
        summary.find('.order-totals-table .order-shipping .label a').hide();
        if (stepCount == 0) {
	        $cache.secondary.find('.rightbutton').on('click',function(){
	        	var userName = $('.login-form .username input').val();
	        	var password = $('.login-form .password input').val();
	        	var guestmail = $('.guest-form .emailAddress input').val();
	        	if (userName != null && userName != '' && userName != undefined && password != null && password != undefined && password != '') {
	        		$cache.primary.find('.spc-login-btn:not(:disabled)').trigger('click');
	        	} else {
	        		$cache.primary.find('.spc-guest-btn:not(:disabled)').trigger('click');
	        	}
	    	});
    	} else if (stepCount == 1) {
    		$('#secondary').find('.rightbutton').on('click',function(){
    			$('#primary').find('.spc-shipping-btn').trigger('click');
	    	});
	        formPrepare.init({
		    	continueSelector: '[name$="shippingAddress_save"],[name$="submit_form"]',
		        formSelector:'[id$="singleshipping_shippingAddress"]'
		    });
    	} else if (stepCount == 2) {
            $cache.secondary.on('click','.rightbutton',function(){
	        	if ($cache.primary.find('.spc-saveAddr-btn').is(':visible')) {
	        		$cache.primary.find('.spc-saveAddr-btn').trigger('click');
	        	} else if($('.spc-billing-btn').length) {
	        		$cache.primary.find('.spc-billing-btn').trigger('click');
	        	} else {
                    $cache.primary.find('.billing-button').trigger('click');
                }
	    	});
            if ($('#is-PayPal').is(':checked') || $('#is-PayPalPayLater').is(':checked')){
                require('./pages/checkout/billing').init();
            }
	        formPrepare.init({
	            formSelector: 'form[id$="billing"]',
	            continueSelector: '[name$="billing_save"],[name$="submit_form"],[name$="selectpaymentmethod"],[name$="_billing_saveAddress"]'
	        });
    	} else if (stepCount > 2) {
    		$cache.secondary.off('click','.rightbutton').on('click','.rightbutton',function(){
    			if ($('.submit-order').length > 0 ) {
    				$('.submit-order button').trigger('click');
    			} else {
    				$('.submit-express-order button.spc-summary-btn').trigger('click');
    			}
        	});
    		if ($('#express-order-submit').length > 0) {
             	formPrepare.init({
                     formSelector: 'form[id$="express-order-submit"]',
                     continueSelector: '[name$="submit"]'
                 });
             } else {
            	 $('.button-fancy-large.rightbutton.final-submit').removeAttr("disabled");
             }
    	}
    });
}

function updateAnchor(noDefault) {
    var erroredElements = $cache.primary.find('.form-row.error:visible').filter(function (i, ele) {
        return $.trim($(ele).html()).length > 0;
    });

    if (erroredElements.length > 0) {
        jQuery('html, body').animate({
            scrollTop: erroredElements.first().position().top
        }, 500);

    } else if ($('.billing-error').length > 0) {
        jQuery('html, body').animate({
            scrollTop: $('.billing-error').position().top
        }, 500);
    }
}

function handleBasketError() {
    if ($cache.primary.find('.pt_cart').length > 0 || $cache.primary.find('.pt_cart_template_b').length > 0) {
        window.location.href = Urls.cartShow;
    }
}

function updateCustomerInfo() {
    ajax.load({
        url: Urls.customerInfo,
        method: 'POST',
        async: false,
        callback: function (data) {
        	$('.menu-utility').find('.menu-utility-user').find('.user-info').remove();
        	$('.menu-utility .menu-utility-user').html($(data));
            $('.user-account').on('click', function (e) {
                e.preventDefault();
                $(this).parent('.user-info').toggleClass('active');
            });
        }
    });
}

/* SC-11047, SC-11048, SC-11198 */
function initiateSMSVibesPhoneInput(){
	var smsVibesPhoneInput = $(".checkout-sms-signup.phone-field .sms-sign-up-phone-field .input-text");
	if(smsVibesPhoneInput.length){
		if(typeof $.validator.methods.smsVibesValidation !== "function"){
			$.validator.addMethod("smsVibesValidation", function(value, elem){
				$(elem).val(smsOptModal.phone.format(value));
				if(value !== "" && $.trim(value).match(/^(\([0-9]{3}\)\s|[0-9]{3}-)[0-9]{3}-[0-9]{4}$/) === null){
					return false;
				}
				return true;
			},"Invalid Phone Number");
		}
		smsVibesPhoneInput.rules("add", {
			smsVibesValidation: true
		});
		smsVibesPhoneInput.on("input keyup", function(){
            $(this).val(smsOptModal.phone.format($(this).val()));
		});
        smsVibesPhoneInput.on("focus", function(){
            $(this).removeAttr("aria-invalid");
            $(this).closest(".sms-sign-up-phone-field.phoneNo").removeClass("error-handle").find("label .error").remove();
		});
		var smsSignUpChkBx = $(".checkout-sms-signup.phone-field .sms-singup-checkbox input");
		var smsVibesToggleElems = $(".checkout-sms-signup.phone-field .sms-sign-up-phone-field, .checkout-sms-signup.phone-field ~ .checkout-guest-btn ~ .content-asset");
		smsVibesToggleElems.closest(".checkoutlogin-col-wrapper").addClass("smsvibes");
		smsSignUpChkBx.off("change").on("change", function(){
			if(this.checked){
				smsVibesToggleElems.show();
			}else{
				smsVibesToggleElems.hide();
			}
		});
		smsSignUpChkBx.trigger("change");
	}
}
/* End: SC-11047, SC-11048, SC-11198 */

function updateContent(URL,stepCount,editship){
	ajax.load({
        url: URL,
        method: 'POST',
        callback: function (data) {
            $cache.primary.html(data);
            handleBasketError();
            initSPC();
            validator.init();
            if ($cache.primary.find('.spc-login').length === 0) {
                tooltip.init();
                util.limitCharacters();
                checkout.init();
            } else {
                var $loginForm = $(document.getElementsByClassName('login-form'));
                $('body').off('blur').on('blur','.login-form .form-row.username .input-text.email', function (e) {
                    util.validateEmailOnFocusOut($loginForm);
                });
                $('body').off('blur').on('blur','.login-form .form-row.password .input-text.password', function (e) {
                    util.validatePasswordOnFocusOut($loginForm);
                });
                var $chkoutGuestLoginForm = $('.checkout-tabs .checkoutlogin .guest-form');
                $('body').off('blur','.checkout-tabs .checkoutlogin .guest-form input.input-text').on('blur','.checkout-tabs .checkoutlogin .guest-form input.input-text', function (e) {
                    util.validateGuestEmailOnFocusOut($chkoutGuestLoginForm);
                });
            }
            $('.header-mian-banner').find('.checkout-progress-indicator').html($('.checkoutinfo').find('.checkout-progress-indicator').html());

            updateSummary(stepCount);
            scrollToActiveTab();
            util.updateselect();
            $('.cvn input').on('input change',function(){
        		util.allowDigits($(this));
        	});
            if(editship != undefined && editship){
            	$('.shipping-add-edit').trigger('click', editship);
            } else if(editship == undefined && stepCount=='1') {
            	var $form = $('.address');
                var selected = $('.shipping-add-edit').closest($cache.primary).find('select[name$="_addressList"]').children(':selected').first();
                var selectedAddress = $(selected).data('address');
                util.fillAddressFields(selectedAddress, $form);
            	if (selectedAddress != undefined) {
                	$('.fieldsection').hide();
                } else {
                	$('.fieldsection').show();
                	$('.edit-section').addClass('hide');
                }
                $('.saved-address-count').removeClass('hide');
                $('.nickname-field').find('input').val('');
            }
            initiateSMSVibesPhoneInput();
            $('input[name$="_creditCard_makeDefault"]').trigger('change');
            progress.hide();
        }
    });
}

function initPreScreen () {
	var URL = Urls.summary;
	ajax.load({
        url: URL,
        method: 'POST',
        callback: function (data) {
            $cache.primary.html(data);
            handleBasketError();
            if ($(data).find('.checkout-billing').length >= 1) {
            	updateSummary(2);
            } else {
            	updateSummary(3);
            }
            initSPC();
            if ($cache.primary.find('.spc-summary').length === 0) {
                tooltip.init();
                util.limitCharacters();
                validator.init();
            }
            checkout.init();
            $('.header-mian-banner').find('.checkout-progress-indicator').html($('.checkoutinfo').find('.checkout-progress-indicator').html());
            progress.hide();
            if ($cache.primary.find('.spc-billing').length === 0) {
                updateAnchor();
            } else {
                updateAnchor(true);
            }

            $cache.secondary.find('.rightbutton').on('click',function(){
        		$('.submit-order button').trigger('click');
        	});
        }
    });
}

function populateCreditCardForm(cardID) {
    // load card details
    var url = util.appendParamToURL(Urls.billingSelectCC, 'creditCardUUID', cardID);
    ajax.getJson({
        url: url,
        callback: function (data) {
            if (!data) {
                window.alert(Resources.CC_LOAD_ERROR);
                return false;
            }
            if(!$('#is-PayPal').is(':checked')) {
            	if( !util.newCardFlag ) {
            		setCCFields(data);
            	} else {
            		$('.payment-method .billingfields input').val('');
            		$('input[name$="_creditCard_saveCard"]').val("false");
            		$('.payment-method .billingfields select').val('').trigger('change');
            		$('.billingfields').removeClass('hide');
            	}
            } else {
        		$('.billingfields').addClass('hide');
            }
            if ($('#express-order-submit').length > 0) {
            	formPrepare.init({
                    formSelector: 'form[id$="express-order-submit"]',
                    continueSelector: '[name$="submit"]'
                });
            } else {
            	formPrepare.init({
                    formSelector: 'form[id$="billing"]',
                    continueSelector: '[name$="billing_save"],[name$="submit_form"],[name$="_billing_saveAddress"]'
                });
            }
            progress.hide();
            util.newCardFlag = false;
        }
    });
}

function scrollToActiveTab(){
	if(!$(".ui-dialog").is(":visible")) {
		var xpressCheckout = $(".checkout-tabs").hasClass("spc-express-checkout");
		var $checkoutHeaderHeight = $('.header-mian-banner').outerHeight();
        var $errorMessageHeight = 110; 
		if(xpressCheckout) {
			$(window).load(function(){
				if(!$(".ui-dialog").is(":visible")) {
					if($('.checkout-tab-head.open').length) {
						if ($('.carddetails.selected').hasClass('plcccard')) {
							$('html, body').animate({ scrollTop: $('.checkout-tab-head.open').offset().top - $('.pt_checkout #header').outerHeight() - 12 }, 700);
						} else {
							$('html, body').animate({ scrollTop: $('.card-list').find('.carddetails.selected').offset().top - $('.pt_checkout #header').outerHeight() - 12 }, 700);
						}
					}
				}
			});
		} else {
			if($(window).width() < 768) {
				$checkoutHeaderHeight = $('.fixed-header').outerHeight();
                $errorMessageHeight = 125; 
			}

			var $cardInputElement=$('.input-text.creditcardnumber');
			if($cardInputElement.length &&  $cardInputElement.closest('.form-row').hasClass('error-handle')){
				$('html, body').animate({ scrollTop: $cardInputElement.offset().top - $checkoutHeaderHeight - 15 }, 700);
				$cardInputElement.focus();
			}else if($('.checkout-tab-head.open').length){
                if ($(".av-plcc-error-message").length > 0 && $(".spc-billing").length > 0) {
                    $('html, body').animate({ scrollTop: $('.checkout-tab-head.open').offset().top - $checkoutHeaderHeight - $errorMessageHeight }, 700);
                } else {
                    $('html, body').animate({ scrollTop: $('.checkout-tab-head.open').offset().top - $checkoutHeaderHeight - 15 }, 700);
                }
                if(window.enterKeyCheckoutFormSubmit){
                	$('.checkout-tab-content.tab-content-show').find(':focusable').eq(0).focus().addClass('focus-outline');
                }
			}
		}

	}
}

function bindTealiumEventXButton(){
    tealium.triggerEvent({ event_name: 'closemodal'});
}

function bindAjaxToPasswordReset(){
    $('body').off('click','.reset_password_button').on('click','.reset_password_button', function(e) {
        e.preventDefault();
        validator.init();
        var $requestPasswordForm = $('[name$="PasswordResetForm"]');
        var data = $requestPasswordForm.serialize();
        var url = util.appendParamToURL($requestPasswordForm.attr('action'), 'format', 'ajax');
        var dataJson = {status : false};
        ajax.load({
            url: url,
            data: data,
            method: 'POST',
            callback: function (data) {
                try {
                    dataJson = JSON.parse(data);
                } catch (error) {
                    return;
                }
                
                if(dataJson.status == true){
                    dialog.open({
                        url: dataJson.url,
                        options : {
                            dialogClass: 'pt_account password_reset_checkout_modal',
                            width: 748,
                            open: function() {
                                $('.closeModalXButton').unbind('click', bindTealiumEventXButton );
                            }
                        }
                    });
                }
            }
        });


    });
}

/**
 * @function
 * @description Fills the Credit Card form with the passed data-parameter and clears the former cvn input
 * @param {Object} data The Credit Card data (holder, type, masked number, expiration month/year)
 */
function setCCFields(data) {
    var $creditCard = $('[data-method="CREDIT_CARD"]');
    $creditCard.find('input[name$="creditCard_owner"]').val(data.holder).trigger('change');
    $creditCard.find('select[name$="_type"]').val(data.type).trigger('change');
    $creditCard.find('input[name*="_creditCard_number"]').val(data.maskedNumber).trigger('change');
    $creditCard.find('[name$="_month"]').val(data.expirationMonth).trigger('change');
    $creditCard.find('[name$="_year"]').val(data.expirationYear).trigger('change');
    $creditCard.find('input[name*="_cvn"]:visible').val('').trigger('change');
}

function updateUtagDataInCheckout(){
	/** update the uatg_data**/
    var checkoutUtagURL=Urls.getCheckoutUtagData;
    $.ajax({
        url: checkoutUtagURL,
        method: 'GET',
        success: function(data) {
            if(data !== ''){
                utag_data=data.utagDL;
             }
        }
    });
}

function formToBuyer(form){
    if(form){
        var phone = form.find('input.phone').val();
        if(phone){
            phone = phone.replace(/\D/g,'');
        }
        return {
            givenName: form.find('input.firstName').val(),
            familyName: form.find('input.lastName').val(),
            phone: phone,
            billingAddress: {
                address1: form.find('input.address1').val(),
                address2: form.find('input.address2').val(),
                locality: form.find('input.city').val(),
                region: form.find('select.required').not('select.country').val(),
                country: form.find('select.country').val(),
                postalCode: form.find('input.postal').val()
            }
        }
    }
}

function initSPC() {
    initializeCache();
    initializeDom();
    initializeEvents();
}

function initCredit() {
	if($('.eds-rtps-data').length){ //If EDS is enabled don't init old PLCC experience
		return;
	}
	if(SitePreferences.PLCCPRESCREENREDESIGN_ENABLED) {
		require('./pages/credit_plcc_redesign').init();
	} else {
		require('./pages/credit').init();
	}
}

function refreshCSRFToken(){
        var csrfURL = Urls.generateCSRFToken;
        $.ajax({
            url: csrfURL,
            method: 'POST',
            success: function(data) {
                var csrfInfo = data.csrf;
                if(csrfInfo){
                //    var tokenName = csrfInfo.tokenName;
                    var token = csrfInfo.token;
                    $('input[name="csrf_token"]').val(token);
                }
            }
        });
}

exports.init = function () {
    require('../../../../SFRA/app_custom_fbb/cartridges/app_custom_fbb/cartridge/client/default/js/components/EDSAnalytics').initEventListeners(tealium);
    initializeCache();
    initializeDom();
    initializeEvents();
   	util.getCityStateOptions();
    util.getAddressSuggestions();
    EDSPrescreen.initEventListeners();
};

exports.initPreScreen = initPreScreen;
exports.scrollToActiveTab = scrollToActiveTab;
exports.initShippingoverlay = initShippingoverlay;
